import { personalitzaCarrusel } from './casos-interessos';

const AUTOPLAY_DELAY = 4500;

function initCarousel(root) {
  const track = root.querySelector('[data-casos-track]');
  const prevButton = root.querySelector('[data-casos-prev]');
  const nextButton = root.querySelector('[data-casos-next]');
  const progress = root.querySelector('[data-casos-progress]');

  if (!track) return;

  personalitzaCarrusel(root);

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer = null;
  let paused = false;
  let visible = false;
  let pageVisible = true;

  const step = () => {
    const card = track.querySelector('[data-casos-card]');
    if (!card) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.offsetWidth + gap;
  };

  const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
  const atStart = () => track.scrollLeft <= 8;

  const go = (direction) => {
    if (direction > 0 && atEnd()) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (direction < 0 && atStart()) {
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: direction * step(), behavior: 'smooth' });
    }
  };

  const restartProgress = () => {
    if (!progress) return;
    progress.style.transition = 'none';
    progress.style.transform = 'scaleX(0)';
    if (paused || !visible || !pageVisible || reducedMotion) return;
    // Forcem el reflow perquè l'animació torni a començar
    void progress.offsetWidth;
    progress.style.transition = `transform ${AUTOPLAY_DELAY}ms linear`;
    progress.style.transform = 'scaleX(1)';
  };

  const schedule = () => {
    clearTimeout(timer);
    restartProgress();
    if (paused || !visible || !pageVisible || reducedMotion) return;
    timer = setTimeout(() => {
      go(1);
      schedule();
    }, AUTOPLAY_DELAY);
  };

  const pause = () => {
    paused = true;
    schedule();
  };

  const resume = () => {
    paused = false;
    schedule();
  };

  prevButton?.addEventListener('click', () => {
    go(-1);
    schedule();
  });
  nextButton?.addEventListener('click', () => {
    go(1);
    schedule();
  });

  root.addEventListener('mouseenter', pause);
  root.addEventListener('mouseleave', resume);
  root.addEventListener('focusin', pause);
  root.addEventListener('focusout', resume);
  // Quan l'usuari fa scroll amb el dit o la roda, deixem de moure-ho sols
  track.addEventListener('wheel', pause, { passive: true });
  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') pause();
  }, { passive: true });

  initMouseDrag(track, schedule);

  new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    schedule();
  }, { threshold: 0.4 }).observe(root);

  document.addEventListener('visibilitychange', () => {
    pageVisible = document.visibilityState === 'visible';
    schedule();
  });
}

// Arrossegar amb el ratolí (amb el dit ja funciona de manera nativa)
function initMouseDrag(track, onRelease) {
  const DRAG_THRESHOLD = 6;
  let startX = 0;
  let startScroll = 0;
  let dragging = false;
  let moved = false;

  track.style.cursor = 'grab';

  // Evitem que el navegador arrossegui els enllaços com a fitxers
  track.addEventListener('dragstart', (event) => event.preventDefault());

  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    dragging = true;
    moved = false;
    startX = event.clientX;
    startScroll = track.scrollLeft;
  });

  window.addEventListener('pointermove', (event) => {
    if (!dragging) return;
    const delta = event.clientX - startX;
    if (!moved && Math.abs(delta) < DRAG_THRESHOLD) return;
    if (!moved) {
      moved = true;
      // Durant l'arrossegament, sense snap ni scroll suau perquè segueixi el ratolí
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
    }
    track.scrollLeft = startScroll - delta;
  });

  window.addEventListener('pointerup', () => {
    if (!dragging) return;
    dragging = false;
    if (!moved) return;

    track.style.cursor = 'grab';
    document.body.style.userSelect = '';

    // Encaixem a la targeta més propera amb animació i recuperem el snap
    const card = track.querySelector('[data-casos-card]');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = card ? card.offsetWidth + gap : track.clientWidth;
    const target = Math.round(track.scrollLeft / step) * step;
    track.style.scrollBehavior = '';
    track.scrollTo({ left: target, behavior: 'smooth' });
    setTimeout(() => {
      track.style.scrollSnapType = '';
    }, 400);
    onRelease();
  });

  // Si s'ha arrossegat, el clic final no ha d'obrir l'enllaç
  track.addEventListener('click', (event) => {
    if (moved) {
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }
  }, true);
}

export function initCasosCarousels() {
  document.querySelectorAll('[data-casos-carousel]').forEach(initCarousel);
}
